// project import
import MainLayout from 'layout/MainLayout';
import CommerceRoutes from './CommerceRoutes';
import ContactsRoutes from './ContactsRoutes';
import AuthGuard from 'utils/route-guard/AuthGuard';

// ==============================|| APPS ROUTING ||============================== //
const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [CommerceRoutes, ContactsRoutes]
    }
  ]
};

export default MainRoutes;
